export default "__VITE_ASSET__CiQYFcnc__"